import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import BasePracticeScenario from "../../../../base-practice-scenario/BasePracticeScenario";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart8Config, GeneralProceduresCricMainConfig, GeneralProceduresCricPart9Config } from "../GeneralProceduresCricMain";

export default class GeneralProceduresCricPart9 extends BaseScenarioPart<DaarcBaseScenario> {
	public static isYesClicked = false;
	public static isCricProcedure = false;
	private get config(): GeneralProceduresCricPart9Config {
		return this.scenarioConfig.part9Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		GeneralProceduresCricPart9.isCricProcedure = true;
		setTimeout(() => {
			context.scenario.uiWrapper.displayGeneralAlertUI({
				title: 'Message',
				text: 'You have finished arranging the tools, would you like to call the level 3 OORAM provider to perform the Cric?',
				okButton: {
					title: 'Yes',
					onClicked: () => {
						GeneralProceduresCricPart9.isYesClicked = true;
						context.onDone();
						context.config.onYesClicked();
					}
				},
				cancelbutton: {
					title: 'No',
					onClicked: () => {
						GeneralProceduresCricPart9.isYesClicked = false;
						context.onDone();
						context.config.onNoClicked();
					}
				}
			});
		}, 1000);
		
	}
}